import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireOnboarding = true, adminOnly = false, requirePremium = true }) {
    const { user, loading } = useAuth();
    if (loading) {
        return <div className="flex h-screen items-center justify-center text-sm uppercase tracking-widest text-muted-foreground" data-testid="auth-loading">Loading…</div>;
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    // Hard gate: non-premium users (no admin override) get sent to pricing — paywall wins over onboarding.
    if (requirePremium && !adminOnly && user.premium === false && user.role !== "admin" && !user.admin_override_premium) {
        const reason = user.premium_reason || "premium_required";
        return <Navigate to={`/pricing?paywall=1&reason=${encodeURIComponent(reason)}`} replace />;
    }
    if (requireOnboarding && !user.onboarded && !adminOnly) return <Navigate to="/onboarding" replace />;
    return children;
}
